import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "file-block__header" }
const _hoisted_2 = { class: "file-block__header-title" }
const _hoisted_3 = {
  ref: "$searchBlock",
  class: "file-block__search"
}
const _hoisted_4 = { class: "file-block__search-input" }
const _hoisted_5 = { class: "file-block__search-hashtag" }
const _hoisted_6 = {
  key: 0,
  class: "file-block__advanced-mode"
}
const _hoisted_7 = {
  key: 1,
  class: "file-block__advanced-mode-icons-panel"
}
const _hoisted_8 = {
  key: 0,
  class: "file-block__foulders-list"
}
const _hoisted_9 = {
  key: 1,
  class: "file-block__search-empty"
}
const _hoisted_10 = {
  key: 1,
  class: "file-block__loader"
}

import {
  nextTick,
  onBeforeUnmount,
  onMounted,
  provide,
  reactive,
  ref,
  watch,
} from "vue";
import AppInput from "@/components/ui-kit/input/AppInput.vue";
import AppHashtag from "@/components/ui-kit/hashtag/AppHashtag.vue";
import AppButton from "@/components/ui-kit/button/AppButton.vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";
import AppLoader from "@/components/ui-kit/loader/AppLoader.vue";
import FileFolder from "@/components/file/FileFolder.vue";
import FileInfoModal from "@/components/file/modals/FileInfoModal.vue";
import FileMoveModal from "@/components/file/modals/FileMoveModal.vue";
import {
  DragEntity,
  DragGeneralState,
  DragStateEx,
  FileOut,
  FolderOut,
  JobBinding,
  TagSignable,
} from "@/models/interfaces/file/file-model";
import { FileApi } from "@/ api/FileApi";
import FileDragElement from "@/components/file/FileDragElement.vue";
import { ProjectApi } from "@/ api/ProjectApi";
import { ProjectContainer } from "@/models/interfaces/project/project-models";
import { workerStore } from "@/store/worker";
import { searchStore } from "@/store/search";
import { jobsStore } from "@/store/jobs";
import { ClientsApi } from "@/ api/ClientsApi";
import { debounce } from "lodash";
import { TagsApi } from "@/ api/TagsApi";
import { TagWithFrequency } from "@/models/interfaces/tags/tag-models";
import { TagBaseType, TagEntityType } from "@/models/etc/types";
import {
  FILE_JOB_BINDING_ADDED_EVENT,
  FileJobBindingAddedDetail,
} from "@/utils/fileJobBindings";
import { i18n } from "@/i18n";

interface Props {
  id: number;
  rootName?: string;
  type?: "project" | "client";
  ruleAccess: number;
}

type FolderTag = FolderOut["Tags"][number];

export default /*@__PURE__*/_defineComponent({
  __name: 'FileBlock',
  props: {
    id: {},
    rootName: { default: "" },
    type: { default: "project" },
    ruleAccess: { default: 0 }
  },
  setup(__props: any) {

const workerStorage = workerStore();
const searchStoreInstance = searchStore();

const isSystemFolderName = (name: string, key: string): boolean => {
  const russianMessages = i18n.global.getLocaleMessage("ru") as Record<string, unknown>;
  return name === String(i18n.global.t(key)) || name === String(russianMessages[key] ?? "");
};

const props = __props;

const advancedMode = ref(false);
const searchMode = ref(false);
const searchText = ref("");
const searchTextSucces = ref("");
const changeMode = () => {
  advancedMode.value = !advancedMode.value;
};

const isAdmin= workerStorage.workerProfile?.IsAdmin;

const $fileInfoModal = ref<typeof FileInfoModal | null>(null);
const $fileMoveModal = ref<typeof FileMoveModal | null>(null);
const $fileBlock = ref<HTMLElement | null>(null);
const $folderTreeElement = ref<HTMLElement | null>(null);
const savedHeight = ref<number | null>(null);
const titleModalInfo = ref();
const typeCard = ref("error");
const errorType = ref("folder");
let container;
let containerFile;
const containerProject = ref<ProjectContainer>();
let formdataTemp: FormData;
const newDirFocus = ref(false);
const renameFolderFocus = ref(false);
const renameFileFocus = ref(false);
const dirFocusId = ref(0);
const countSelected = ref<number>(0);
const handleClearSearch = ref(0);
const openSearchFoldersIdList = ref<number[]>([]);
const searchAutoOpenEnabled = ref(true);
const ignoreWatcher = ref(false);
const openAfterMoveFolderId = ref<number | null>(null);
const pendingMoveOpenFolderId = ref<number | null>(null);
const modalPos = ref<{ x: number; y: number }>({ x: 0, y: 0 });
const typeInfoModal = ref<"default" | "modalPermitions">("default");
const isModalOpened = ref(false);
const isLoading = ref(false);
const percentUploading = ref(0);
const preSearchHeight = ref(0);
const flashFileId = ref<number | null>(null);

let resolveReplaceUploadChoice: ((value: boolean | null) => void) | null = null;

const waitReplaceUploadChoice = (): Promise<boolean | null> => {
  return new Promise((resolve) => {
    resolveReplaceUploadChoice = resolve;
  });
};

const searchTags = ref<TagSignable[]>([]);
const selectedTags = ref<TagWithFrequency[]>([]);
const isTagsUpdating = ref(false);
const changeTags = async (newSelectedTags: TagWithFrequency[]) => {
  if (isTagsUpdating.value) return;

  const currentFolderTags: FolderTag[] = searchTags.value ?? [];
  const nextSelectedTags: TagWithFrequency[] = newSelectedTags ?? [];

  const addedTags = nextSelectedTags.filter(
    (selectedTag) =>
      !currentFolderTags.some((folderTag) => isSameTag(folderTag, selectedTag)),
  );

  const removedTags = currentFolderTags.filter(
    (folderTag) =>
      !nextSelectedTags.some((selectedTag) =>
        isSameTag(folderTag, selectedTag),
      ),
  );

  if (addedTags.length === 0 && removedTags.length === 0) {
    return;
  }

  isTagsUpdating.value = true;

  try {
    searchTags.value = nextSelectedTags.map(mapSelectorTagToFolderTag);
  } catch (error) {
    console.error("Failed to change folder tags", error);
    selectedTags.value = currentFolderTags.map(mapFolderTagToSelectorTag);
  } finally {
    isTagsUpdating.value = false;
  }
};

const removeTag = async (item: { Id: any; Name: string }) => {
  if (isTagsUpdating.value) return;

  const nextSelectedTags = (selectedTags.value ?? []).filter(
    (tag) => !isSameTag(tag, item),
  );

  await changeTags(nextSelectedTags);
};

const isSameTag = (
  a: { Id: any; Name: string },
  b: { Id: any; Name: string },
): boolean => {
  const aIdExists = a.Id !== null && a.Id !== undefined;
  const bIdExists = b.Id !== null && b.Id !== undefined;

  if (aIdExists && bIdExists) {
    return String(a.Id) === String(b.Id);
  }

  return a.Name.trim().toLowerCase() === b.Name.trim().toLowerCase();
};

const mapFolderTagToSelectorTag = (tag: FolderTag): TagWithFrequency => ({
  ...tag,
  Frequency: 0,
  FullName: tag.Name,
  Type: TagBaseType.Common,
});

const mapSelectorTagToFolderTag = (tag: TagWithFrequency): FolderTag => ({
  Signed: false,
  SignedBy: "",
  SignedAt: null as unknown as Date,
  Id: tag.Id,
  Name: tag.Name,
});

provide("openAfterMoveFolderId", openAfterMoveFolderId);

const selectAll = () => {
  handleChildEvent({ type: "selectAll" });
};

const deselectAll = () => {
  handleChildEvent({ type: "deselect" });
};

provide("mode", advancedMode);
provide("searchMode", searchMode);
provide("searchText", searchTextSucces);
provide("containerProject", containerProject);
provide("isAdmin", isAdmin);
provide("newDirFocus", newDirFocus);
provide("dirFocusId", dirFocusId);
provide("renameFileFocus", renameFileFocus);
provide("renameFolderFocus", renameFolderFocus);
const pendingRenameFocus = ref<"folder" | "file" | "new-folder" | null>(null);
provide("openSearchFoldersIdList", openSearchFoldersIdList);
provide("modalPos", modalPos);
provide("percentUploading", percentUploading);
provide("flashFileId", flashFileId);

// FileBlock.vue
const searchOpenedFolderIds = ref<number[]>([]);
const restoreOpenedFolderIds = ref<number[]>([]);

provide("searchOpenedFolderIds", searchOpenedFolderIds);
provide("openSearchFoldersIdList", restoreOpenedFolderIds);

provide("handleClearSearch", handleClearSearch);
provide("isModalOpened", isModalOpened);
provide("searchAutoOpenEnabled", searchAutoOpenEnabled);
provide("isModalOpenedChange", (value: boolean) => {
  isModalOpened.value = value;
});
provide("disableNewDirFocus", () => {
  newDirFocus.value = false;
});
provide("disableRenameFileFocus", () => {
  renameFileFocus.value = false;
});
provide("changeElFocusId", (value: number) => {
  dirFocusId.value = value;
});
provide("disableRenameFolderFocus", () => {
  renameFolderFocus.value = false;
});
provide("changeModalPos", (value: { x: number; y: number }) => {
  modalPos.value = { ...value };
});

const resetModalPos = () => {
  modalPos.value = null;
};

let folder = ref<FolderOut>();

let scrollObserver: IntersectionObserver | null = null;
let scrollSentinel: HTMLElement | null = null;
let scrollUnlockCleanup: (() => void) | null = null;

const getScrollParent = (el: HTMLElement): Element | Window => {
  let parent = el.parentElement;
  while (parent && parent !== document.documentElement) {
    const { overflow, overflowY } = window.getComputedStyle(parent);
    if (/(auto|scroll)/.test(overflow + overflowY)) return parent;
    parent = parent.parentElement;
  }
  return window;
};

const attachScrollUnlock = () => {
  detachScrollUnlock();
  if (!$folderTreeElement.value || savedHeight.value === null) return;

  const el = $folderTreeElement.value;
  const lockedHeight = savedHeight.value;

  el.style.minHeight = "";
  const contentHeight = el.scrollHeight;
  el.style.minHeight = `${lockedHeight}px`;

  if (contentHeight >= lockedHeight) {
    unlockHeight();
    return;
  }

  const scrollEl = getScrollParent(el);

  const getScroll = () =>
    scrollEl === window ? window.scrollY : (scrollEl as Element).scrollTop;

  const getViewportH = () =>
    scrollEl === window
      ? window.innerHeight
      : (scrollEl as Element).clientHeight;

  const elRect = el.getBoundingClientRect();
  const containerOffset =
    scrollEl === window
      ? window.scrollY
      : (scrollEl as Element).scrollTop -
        (scrollEl as Element).getBoundingClientRect().top;
  const elementTopDoc = elRect.top + containerOffset;

  const updateMinHeight = () => {
    if (!$folderTreeElement.value) {
      detachScrollUnlock();
      return;
    }

    const scroll = getScroll();
    const viewportH = getViewportH();

    const neededHeight = scroll + viewportH - elementTopDoc;

    const newMinHeight = Math.max(
      contentHeight,
      Math.min(lockedHeight, neededHeight),
    );

    savedHeight.value = newMinHeight;
    el.style.minHeight = `${newMinHeight}px`;

    if (newMinHeight <= contentHeight) {
      detachScrollUnlock();
      el.style.minHeight = "";
      el.style.overflow = "";
      savedHeight.value = null;
    }
  };

  updateMinHeight();

  (scrollEl as EventTarget).addEventListener("scroll", updateMinHeight, {
    passive: true,
  });
  scrollUnlockCleanup = () =>
    (scrollEl as EventTarget).removeEventListener("scroll", updateMinHeight);
};

const detachScrollUnlock = () => {
  scrollUnlockCleanup?.();
  scrollUnlockCleanup = null;
  if (scrollObserver) {
    scrollObserver.disconnect();
    scrollObserver = null;
  }
  scrollSentinel?.remove();
  scrollSentinel = null;
};

const onPressEsc = async () => {
  try {
    lockHeight();

    if (!searchMode.value) return;

    isLoading.value = true;
    ignoreWatcher.value = true;

    const searchTree = folder.value;
    const openedInSearch = new Set(searchOpenedFolderIds.value);

    searchMode.value = false;
    restoreOpenedFolderIds.value = [];
    searchText.value = "";
    searchTextSucces.value = "";
    changeTags([]);

    await reloadTree(searchTree, openedInSearch);

    restoreOpenedFolderIds.value = [...openedInSearch];
    searchOpenedFolderIds.value = [];

    nextTick(() => {
      ignoreWatcher.value = false;
    });
  } finally {
    isLoading.value = false;
    await nextTick();
    unlockHeight();
  }
};

const collectBranchIds = (node?: FolderOut): number[] => {
  if (!node) return [];

  return [
    node.Id,
    ...(node.Folders ?? []).flatMap((child) => collectBranchIds(child)),
  ];
};

const collectNonEmptyBranchIds = (node?: FolderOut): number[] => {
  if (!node) return [];

  const childIds = (node.Folders ?? []).flatMap((child) =>
    collectNonEmptyBranchIds(child),
  );
  const hasTreeContent =
    (node.Folders?.length ?? 0) > 0 || (node.Files?.length ?? 0) > 0;

  return hasTreeContent ? [node.Id, ...childIds] : childIds;
};

const removeBranchFromOpened = (
  openedIds: number[],
  branch: FolderOut,
): number[] => {
  const idsToRemove = new Set(collectBranchIds(branch));
  return openedIds.filter((id) => !idsToRemove.has(id));
};

const loadFolders = async () => {
  try {
    if (props.type === "project") {
      folder.value = await FileApi.getProjectFolders(props.id);
      containerProject.value = await ProjectApi.GetProject(props.id);
    } else {
      folder.value = await FileApi.getClientFolders(props.id);
      containerProject.value = await ClientsApi.getClient(props.id);
    }
  } catch (error) {
    console.error(error);
  }
};

const searchFolders = async () => {
  const normalizedSearchText = searchText.value.trim();
  if (!normalizedSearchText && searchTags.value.length === 0) return;

  if (!searchMode.value && $folderTreeElement.value) {
    preSearchHeight.value = $folderTreeElement.value.offsetHeight;
  }
  lockHeight();
  isLoading.value = true;
  try {
    folder.value =
      props.type === "project"
        ? await FileApi.projectFileSearch(
            props.id,
            normalizedSearchText || null,
            searchTags.value.map((tag) => tag.Id),
          )
        : await FileApi.clientFileSearch(
            props.id,
            normalizedSearchText || null,
            searchTags.value.map((tag) => tag.Id),
          );

    if (folder.value) {
      folder.value.Name = String(i18n.global.t("file_search_results"));
    }

    searchMode.value = true;
    searchTextSucces.value = searchText.value;

    searchOpenedFolderIds.value = collectNonEmptyBranchIds(folder.value);
    restoreOpenedFolderIds.value = [];
  } finally {
    isLoading.value = false;
    await nextTick();
    attachScrollUnlock();
  }
};

const consumeFileSearchRequest = async () => {
  const req = searchStoreInstance.pendingFileSearch;
  if (!req || req.type !== props.type || req.id !== props.id) return;
  searchStoreInstance.clearPendingFileSearch();

  ignoreWatcher.value = true;
  searchText.value = req.fileName;
  await nextTick();
  ignoreWatcher.value = false;

  await searchFolders();
  await nextTick();
  await nextTick();

  const findFileInTree = (currentFolder: FolderOut): FileOut | null => {
    for (const file of currentFolder.Files ?? []) {
      if (file.Id === req.fileId) return file;
    }
    for (const subfolder of currentFolder.Folders ?? []) {
      const found = findFileInTree(subfolder);
      if (found) return found;
    }
    return null;
  };

  if (folder.value) {
    const targetFile = findFileInTree(folder.value);
    if (targetFile) {
      setTimeout(() => {
        flashFileId.value = targetFile.Id;
        setTimeout(() => {
          flashFileId.value = null;
        }, 1200);
      }, 100);
    }
  }
};

watch(
  () => searchTags.value,
  async (tags) => {
    selectedTags.value = (tags ?? []).map(mapFolderTagToSelectorTag);

    if (searchText.value.length >= 3 || tags.length > 0) {
      searchFolders();
    } else if (
      tags.length == 0 &&
      searchText.value.length == 0 &&
      searchMode.value
    ) {
      lockHeight();
      try {
        isLoading.value = true;

        debouncedSearch.cancel();

        searchMode.value = false;
        searchTextSucces.value = "";
        openSearchFoldersIdList.value = [];
        handleClearSearch.value++;
        loadFolders();
      } catch (error) {
        console.log(error);
      } finally {
        isLoading.value = false;
        await nextTick();
        attachScrollUnlock();
      }
    }
  },
  { deep: true },
);

const reloadTree = async (
  searchTree?: FolderOut,
  openedInSearch: Set<number> = new Set(),
) => {
  await loadFolders();

  const projectRoot = folder.value;
  if (!searchTree || !projectRoot) return;

  if (openedInSearch.has(projectRoot.Id)) {
    restoreOpenedFolderIds.value.push(projectRoot.Id);
  }

  for (const searchBranch of searchTree.Folders ?? []) {
    await mergeSearchTreeIntoProject(projectRoot, searchBranch, openedInSearch);
  }
};

const mergeSearchTreeIntoProject = async (
  projectRoot: FolderOut,
  searchNode: FolderOut,
  openedInSearch: Set<number>,
): Promise<void> => {
  const target = findFolderById(projectRoot, searchNode);
  if (!target) return;

  const isOpened = openedInSearch.has(searchNode.Id);

  if (!isOpened) return;

  const isProjectRootFolder =
    searchNode.Id === 0 && searchNode.ProjectId !== 0;

  const fullFolder = isProjectRootFolder
    ? await FileApi.getProjectFolders(searchNode.ProjectId)
    : searchNode.Id !== 0
      ? await FileApi.getChildFolders(searchNode.Id)
      : searchNode;

  restoreOpenedFolderIds.value.push(searchNode.Id);

  if ((searchNode.Id !== 0 || searchNode.ProjectId !== 0) && fullFolder) {
    target.Files = fullFolder.Files;
    target.Folders = fullFolder.Folders;
    target.Editable = fullFolder.Editable;
  }

  for (const child of searchNode.Folders ?? []) {
    await mergeSearchTreeIntoProject(projectRoot, child, openedInSearch);
  }
};

const debouncedSearch = debounce(searchFolders, 1000);

watch(searchText, async (newVal, oldVal) => {
  if (ignoreWatcher.value) return;

  if (newVal !== oldVal && newVal !== "" && searchText.value.length >= 3) {
    debouncedSearch();
  } else if (!newVal && searchTags.value.length > 0) {
    debouncedSearch.cancel();
    await searchFolders();
  } else if (!newVal && searchTags.value.length === 0) {
    lockHeight();

    try {
      isLoading.value = true;

      debouncedSearch.cancel();

      searchMode.value = false;
      searchTextSucces.value = "";
      openSearchFoldersIdList.value = [];
      handleClearSearch.value++;
      await loadFolders();
    } catch (error) {
      console.log(error);
    } finally {
      isLoading.value = false;
      await nextTick();
      attachScrollUnlock();
    }
  }
});

watch(searchMode, (val) => {
  if (!val) {
    searchAutoOpenEnabled.value = true;
  }
});

const lockHeight = () => {
  detachScrollUnlock();
  if ($folderTreeElement.value) {
    const current = $folderTreeElement.value.offsetHeight;
    const h = searchMode.value
      ? savedHeight.value ?? current
      : Math.max(current, preSearchHeight.value || 0);
    if (h === 0) return;
    savedHeight.value = h;
    $folderTreeElement.value.style.minHeight = `${h}px`;
  }
};

const unlockHeight = async () => {
  detachScrollUnlock();
  await nextTick();
  if ($folderTreeElement.value) {
    $folderTreeElement.value.style.minHeight = "";
    $folderTreeElement.value.style.overflow = "";
  }
  savedHeight.value = null;
};

const handleFileJobBindingAdded = async (event: Event) => {
  const { fileId, jobId, fileCreated, projectId, clientIds } = (
    event as CustomEvent<FileJobBindingAddedDetail>
  ).detail;

  if (!folder.value) return;

  const belongsToCurrentEntity =
    props.type === "project"
      ? projectId == null || projectId === props.id
      : !clientIds?.length || clientIds.includes(props.id);

  if (!belongsToCurrentEntity) return;

  let fileFound = false;

  const updateFileBindings = (currentFolder: FolderOut): FolderOut => ({
    ...currentFolder,
    Files: (currentFolder.Files ?? []).map((file) => {
      if (file.Id !== fileId) return file;

      fileFound = true;

      const bindings = file.JobBindings ?? [];
      if (bindings.some((binding) => binding.JobId === jobId)) return file;

      return {
        ...file,
        JobBindings: [...bindings, { JobId: jobId } as JobBinding],
      };
    }),
    Folders: (currentFolder.Folders ?? []).map(updateFileBindings),
  });

  folder.value = updateFileBindings(folder.value);

  if (fileCreated && !fileFound) {
    if (searchMode.value) {
      await searchFolders();
    } else {
      const refreshedRoot =
        props.type === "project"
          ? await FileApi.getProjectFolders(props.id)
          : await FileApi.getClientFolders(props.id);
      const attachedFile = refreshedRoot.Files?.find(
        (file) => file.Id === fileId,
      );

      if (
        attachedFile &&
        !folder.value.Files?.some((file) => file.Id === attachedFile.Id)
      ) {
        folder.value = {
          ...folder.value,
          Files: [...(folder.value.Files ?? []), attachedFile],
        };
      }
    }
  }
};

onBeforeUnmount(() => {
  detachScrollUnlock();
  window.removeEventListener(
    FILE_JOB_BINDING_ADDED_EVENT,
    handleFileJobBindingAdded,
  );
});

const findFolderById = (
  root: FolderOut,
  search: FolderOut,
): FolderOut | null => {
  if (
    (root.Id == search.Id && root.ProjectId == 0) ||
    (root.ProjectId !== 0 &&
      (search.Id == 0 || root.Name == search.Name) &&
      (root.ProjectId == search.ProjectId || root.Name == search.Name)) ||
    (root.ProjectId == 0 && search.Id == 0 && search.Name == root.Name)
  ) {
    return root;
  }

  for (const child of root.Folders ?? []) {
    const found = findFolderById(child, search);
    if (found) return found;
  }

  return null;
};

const downloadFile = async (fileId: number) => {
  const downloaded = await FileApi.FileDownload(fileId);
  if (downloaded) return;

  typeCard.value = "error";
  errorType.value = "notFound";
  await nextTick();
  $fileMoveModal.value?.onOpen();
};

const downloadSelectedFoldersAndFiles = async (event?: MouseEvent) => {
  if (event) {
    const rect = (event.currentTarget as HTMLElement).getBoundingClientRect();
    modalPos.value = {
      x: rect.right + window.scrollX + 8,
      y: rect.top + window.scrollY,
    };
  }

  let selectedFolders: number[] = [];
  let selectedFiles: number[] = [];

  const findSelectedFoldersInTree = (currentFolder: FolderOut): FolderOut => {
    const findSelectedFilesInTree = (currentFile: FileOut): void => {
      if (currentFile.isSelected === true) {
        selectedFiles.push(currentFile.Id);
      }
    };

    if (
      currentFolder.isSelected == undefined ||
      currentFolder.isSelected == false
    ) {
      currentFolder.Files?.map((subFile) => findSelectedFilesInTree(subFile));
    } else if (currentFolder.isSelected === true) {
      selectedFolders.push(currentFolder.Id);
    }

    if (currentFolder.Folders && currentFolder.Folders.length > 0) {
      return {
        ...currentFolder,
        Folders: currentFolder.Folders?.map((subFolder) =>
          findSelectedFoldersInTree(subFolder),
        ),
      };
    }

    return currentFolder;
  };

  if (folder.value) {
    folder.value = findSelectedFoldersInTree(folder.value);
  }

  if (selectedFolders.length == 0 && selectedFiles.length == 1) {
    await downloadFile(selectedFiles[0]);
  } else if (selectedFolders.length == 1 && selectedFiles.length == 0) {
    FileApi.FolderDownload(selectedFolders[0]);
  } else if (selectedFolders.length == 0 && selectedFiles.length == 0) {
    return;
  } else {
    FileApi.FileAndFolderDownload(
      selectedFolders,
      selectedFiles,
      props.id,
      props.type,
    );
  }
};

const removeFileFromAttachedJobs = (file: FileOut) => {
  const jobIds = file.JobBindings?.map((b) => b.JobId) ?? [];
  if (jobIds.length) {
    jobsStore().removeDeletedFileFromJobs(file.Id, jobIds);
  }
};

const collectFilesInFolder = (folder: FolderOut): FileOut[] => {
  const files: FileOut[] = [...(folder.Files ?? [])];
  folder.Folders?.forEach((sub) => files.push(...collectFilesInFolder(sub)));
  return files;
};

const removeSelectedFoldersAndFiles = async () => {
  let selectedFolders: number[] = [];
  let selectedFiles: number[] = [];
  const filesToSyncWithJobs: FileOut[] = [];

  const findSelectedFoldersInTree = (currentFolder: FolderOut): FolderOut => {
    const findSelectedFilesInTree = (currentFile: FileOut): FileOut => {
      if (currentFile.isSelected === true) {
        selectedFiles.push(currentFile.Id);
        filesToSyncWithJobs.push(currentFile);
      }

      return {
        ...currentFile,
      };
    };

    if (
      currentFolder.isSelected == undefined ||
      currentFolder.isSelected == false
    ) {
      currentFolder.Files?.map((subFile) => findSelectedFilesInTree(subFile));

      currentFolder.Files = currentFolder.Files?.filter(
        (subFile) => subFile.isSelected !== true,
      );
    } else if (currentFolder.isSelected === true) {
      selectedFolders.push(currentFolder.Id);
      filesToSyncWithJobs.push(...collectFilesInFolder(currentFolder));
    }

    if (currentFolder.Folders && currentFolder.Folders.length > 0) {
      const filteredFolders = currentFolder.Folders.map((subFolder) =>
        findSelectedFoldersInTree(subFolder),
      ).filter((subFolder) => subFolder.isSelected !== true);

      return {
        ...currentFolder,
        Folders: filteredFolders,
      };
    }

    return currentFolder;
  };

  if (folder.value) {
    folder.value = findSelectedFoldersInTree(folder.value);
  }

  selectedFolders.map((subFolder) => FileApi.RemoveDir(subFolder));
  selectedFiles.map((subFile) => FileApi.RemoveFile(subFile));

  filesToSyncWithJobs.forEach((file) => removeFileFromAttachedJobs(file));
};

const removeFolder = async (dir: FolderOut) => {
  const nestedFiles = collectFilesInFolder(dir);

  await FileApi.RemoveDir(dir.Id);

  nestedFiles.forEach((file) => removeFileFromAttachedJobs(file));

  const selectFolderInTree = (currentFolder: FolderOut): FolderOut => {
    if (currentFolder.Folders && currentFolder.Folders.length > 0) {
      const filteredFolders = currentFolder.Folders.filter(
        (subFolder) => subFolder.Id !== dir.Id,
      ).map((subFolder) => selectFolderInTree(subFolder));

      return {
        ...currentFolder,
        Folders: filteredFolders,
      };
    }

    return currentFolder;
  };

  if (folder.value) {
    folder.value = selectFolderInTree(folder.value);
  }
};

const removeFile = async (dir: FolderOut, file: FileOut) => {
  await FileApi.RemoveFile(file.Id);

  removeFileFromAttachedJobs(file);

  const selectFolderInTree = (currentFolder: FolderOut): FolderOut => {
    if (currentFolder.Id === dir.Id) {
      return {
        ...currentFolder,
        Files: currentFolder.Files.filter((subFile) => subFile.Id !== file.Id),
      };
    }

    if (currentFolder.Folders && currentFolder.Folders.length > 0) {
      return {
        ...currentFolder,
        Folders: currentFolder.Folders.map((subFolder) =>
          selectFolderInTree(subFolder),
        ),
      };
    }

    return currentFolder;
  };

  if (folder.value) {
    folder.value = selectFolderInTree(folder.value);
  }
};

const setBranchSelection = (
  currentFolder: FolderOut,
  value: boolean,
): FolderOut => {
  return {
    ...currentFolder,
    isSelected: value,
    Files: (currentFolder.Files ?? []).map((file) => ({
      ...file,
      isSelected: value,
    })),
    Folders: (currentFolder.Folders ?? []).map((subFolder) =>
      setBranchSelection(subFolder, value),
    ),
  };
};

const hasInaccessibleElements = (currentFolder: FolderOut): boolean =>
  currentFolder.Editable === false ||
  (currentFolder.Files ?? []).some((file) => file.Editable === false) ||
  (currentFolder.Folders ?? []).some(hasInaccessibleElements);

const selectAccessibleBranch = (
  currentFolder: FolderOut,
  isSelectedFolder = false,
): FolderOut => {
  const folders = (currentFolder.Folders ?? []).map((folder) =>
    selectAccessibleBranch(folder),
  );
  const files = (currentFolder.Files ?? []).map((file) => ({
    ...file,
    isSelected: file.Editable !== false,
  }));

  return {
    ...currentFolder,
    Files: files,
    Folders: folders,
    isSelected:
      !isSelectedFolder && !hasInaccessibleElements(currentFolder),
  };
};

const normalizeSelectionUp = (currentFolder: FolderOut): FolderOut => {
  const normalizedFolders = (currentFolder.Folders ?? []).map((subFolder) =>
    normalizeSelectionUp(subFolder),
  );

  const normalizedFiles = (currentFolder.Files ?? []).map((file) => ({
    ...file,
  }));

  const hasChildren =
    normalizedFolders.length > 0 || normalizedFiles.length > 0;

  const allFilesSelected =
    normalizedFiles.length === 0 ||
    normalizedFiles.every((file) => file.isSelected === true);

  const allFoldersSelected =
    normalizedFolders.length === 0 ||
    normalizedFolders.every((folder) => folder.isSelected === true);

  const branchFullySelected = hasChildren
    ? allFilesSelected && allFoldersSelected
    : true;

  return {
    ...currentFolder,
    Files: normalizedFiles,
    Folders: normalizedFolders,
    isSelected:
      currentFolder.Id !== 0 &&
      currentFolder.isSelected === true &&
      branchFullySelected,
  };
};

const deselectFolders = async () => {
  const deselectFolderInTree = (currentFolder: FolderOut): FolderOut => {
    const deselectFileInTree = (currentFile: FileOut): FileOut => {
      currentFile.isSelected = false;

      return {
        ...currentFile,
      };
    };

    currentFolder.isSelected = false;
    currentFolder.Files?.map((subFile) => deselectFileInTree(subFile));

    if (currentFolder.Folders && currentFolder.Folders.length > 0) {
      return {
        ...currentFolder,
        Folders: currentFolder.Folders.map((subFolder) =>
          deselectFolderInTree(subFolder),
        ),
      };
    }

    return currentFolder;
  };

  if (folder.value) {
    folder.value = deselectFolderInTree(folder.value);
  }
};

const moveSelectedFoldersAndFiles = async (targetFolder: FolderOut) => {
  let selectedFolders: FolderOut[] = [];
  let selectedFiles: FileOut[] = [];

  const collectSelected = (currentFolder: FolderOut) => {
    currentFolder.Files?.forEach((file) => {
      if (file.isSelected === true) {
        selectedFiles.push(file);
      }
    });

    currentFolder.Folders?.forEach((folder) => {
      if (folder.isSelected === true) {
        selectedFolders.push(folder);
      } else {
        collectSelected(folder);
      }
    });
  };

  const removeSelectedFromTree = (currentFolder: FolderOut): FolderOut => {
    return {
      ...currentFolder,
      Files: (currentFolder.Files ?? []).filter(
        (file) => file.isSelected !== true,
      ),
      Folders: (currentFolder.Folders ?? [])
        .filter((folder) => folder.isSelected !== true)
        .map((folder) => removeSelectedFromTree(folder)),
    };
  };

  const insertIntoTarget = (currentFolder: FolderOut): FolderOut => {
    if (currentFolder.Id === targetFolder.Id) {
      return {
        ...currentFolder,
        Folders: [...(currentFolder.Folders ?? []), ...selectedFolders],
        Files: [...(currentFolder.Files ?? []), ...selectedFiles],
      };
    }

    return {
      ...currentFolder,
      Folders: (currentFolder.Folders ?? []).map((folder) =>
        insertIntoTarget(folder),
      ),
    };
  };

  if (!folder.value) return;

  collectSelected(folder.value);

  folder.value = removeSelectedFromTree(folder.value);

  folder.value = insertIntoTarget(folder.value);

  await FileApi.MoveDir(
    targetFolder.Id,
    selectedFolders.map((element) => element.Id),
    selectedFiles.map((element) => element.Id),
  );

  const updatedTarget = await FileApi.getChildFolders(targetFolder.Id);
  const refreshTargetInTree = (currentFolder: FolderOut): FolderOut => {
    if (currentFolder.Id === targetFolder.Id) {
      return {
        ...currentFolder,
        ...updatedTarget,
        Folders: updatedTarget.Folders ?? [],
        Files: updatedTarget.Files ?? [],
      };
    }

    return {
      ...currentFolder,
      Folders: (currentFolder.Folders ?? []).map(refreshTargetInTree),
    };
  };

  folder.value = refreshTargetInTree(folder.value);

  await deselectFolders();
};

const selectCountGeneralState = () => {
  let countSelected = 0;
  let topName = "";
  let topType = "";
  let topFound = false;

  const getFileExtension = (fileName: string): string => {
    const parts = fileName.split(".");
    return parts.length > 1 ? parts.pop()!.toLowerCase() : "file";
  };

  const traverse = (currentFolder: FolderOut, isParentSelected = false) => {
    // Папка
    if (currentFolder.isSelected === true) {
      countSelected++;

      if (!topFound && !isParentSelected) {
        topName = currentFolder.Name;
        topType = "folder";
        topFound = true;
      }

      isParentSelected = true;
    }

    // Файлы
    currentFolder.Files?.forEach((file) => {
      if (file.isSelected === true) {
        countSelected++;

        if (!topFound && !isParentSelected) {
          topName = file.Name;
          topType = getFileExtension(file.Name);
          topFound = true;
        }
      }
    });

    // Дочерние папки
    currentFolder.Folders?.forEach((folder) =>
      traverse(folder, isParentSelected),
    );
  };

  if (!folder.value) {
    return {
      count: 0,
      name: "",
      type: "",
    };
  }

  traverse(folder.value);

  return {
    count: countSelected,
    name: topName,
    type: topType,
  };
};

const hasSelectedProjectFolder = (): boolean => {
  if (!folder.value) return false;

  const getFolderType = (
    parentType:
      | "systemFolder"
      | "systemProjectList"
      | "projectFolder"
      | "default",
    item: FolderOut,
  ): "systemFolder" | "systemProjectList" | "projectFolder" | "default" => {
    if (parentType === "systemFolder" && isSystemFolderName(item.Name, "file_system_projects")) {
      return "systemProjectList";
    }

    if (parentType === "systemProjectList") {
      return "projectFolder";
    }

    return "default";
  };

  const walk = (
    currentFolder: FolderOut,
    currentType:
      | "systemFolder"
      | "systemProjectList"
      | "projectFolder"
      | "default",
  ): boolean => {
    if (currentType === "projectFolder" && currentFolder.isSelected === true) {
      return true;
    }

    for (const child of currentFolder.Folders ?? []) {
      const childType = getFolderType(currentType, child);

      if (walk(child, childType)) {
        return true;
      }
    }

    return false;
  };

  return walk(folder.value, "systemFolder");
};

const syncSelectionState = () => {
  countSelected.value = selectCount();

  Object.assign(dragGeneralState, {
    ...selectCountGeneralState(),
    isValid: !hasSelectedProjectFolder(),
  });
};

const addFileInFolder = async (dir: number, newFile: FileOut) => {
  const updateFolderInTree = (currentFolder: FolderOut): FolderOut => {
    if (currentFolder.Id == dir) {
      if (currentFolder.isSelected === true) {
        return {
          ...currentFolder,
          Files: [
            ...(currentFolder.Files ?? []),
            { ...newFile, isSelected: true },
          ],
        };
      } else if (
        currentFolder.isSelected == undefined ||
        currentFolder.isSelected == false
      ) {
        return {
          ...currentFolder,
          Files: [...(currentFolder.Files ?? []), newFile],
        };
      }
    }

    if (currentFolder.Folders && currentFolder.Folders.length > 0) {
      return {
        ...currentFolder,
        Folders: currentFolder.Folders.map((subFolder) =>
          updateFolderInTree(subFolder),
        ),
      };
    }

    return currentFolder;
  };

  if (folder.value) {
    folder.value = updateFolderInTree(folder.value);
  }
};

const selectCount = (): number => {
  let coutntSelected = 0;
  const selectFolderInTree = (currentFolder: FolderOut): FolderOut => {
    const selectFileInTree = (currentFile: FileOut): FileOut => {
      if (currentFile.isSelected === true) {
        coutntSelected++;
      }

      return {
        ...currentFile,
      };
    };

    if (currentFolder.isSelected === true) {
      coutntSelected++;
    }
    currentFolder.Files?.map((subFile) => selectFileInTree(subFile));

    if (currentFolder.Folders && currentFolder.Folders.length > 0) {
      return {
        ...currentFolder,
        Folders: currentFolder.Folders.map((subFolder) =>
          selectFolderInTree(subFolder),
        ),
      };
    }

    return currentFolder;
  };

  if (folder.value) {
    folder.value = selectFolderInTree(folder.value);
    return coutntSelected;
  }

  return 0;
};

const handleChildEvent = async (eventData: { type: string; data?: any }) => {
  try {
    const openFolder = async (dir: FolderOut) => {
      const updatedFolder = await FileApi.getChildFolders(dir.Id);

      const updateFolderInTree = (currentFolder: FolderOut): FolderOut => {
        if (currentFolder.Id === dir.Id) {
          if (currentFolder.isSelected === true) {
            return {
              ...currentFolder,
              ...updatedFolder,
              Folders:
                updatedFolder.Folders.map((subFolder) => {
                  subFolder.isSelected = true;
                  return subFolder;
                }) || [],
              Files:
                updatedFolder.Files.map((subFile) => {
                  subFile.isSelected = true;
                  return subFile;
                }) || [],
            };
          } else if (
            currentFolder.isSelected == undefined ||
            currentFolder.isSelected == false
          ) {
            return {
              ...currentFolder,
              ...updatedFolder,
              Folders: updatedFolder.Folders || [],
              Files: updatedFolder.Files || [],
            };
          }
        }

        if (currentFolder.Folders && currentFolder.Folders.length > 0) {
          return {
            ...currentFolder,
            Folders: currentFolder.Folders.map((subFolder) =>
              updateFolderInTree(subFolder),
            ),
          };
        }

        return currentFolder;
      };

      if (folder.value) {
        folder.value = updateFolderInTree(folder.value);
      }
    };

    const openProjectFolder = async (dir: FolderOut) => {
      const updatedFolder = await FileApi.getProjectFolders(dir.ProjectId);

      const updateFolderInTree = (currentFolder: FolderOut): FolderOut => {
        if (currentFolder.ProjectId === dir.ProjectId) {
          if (currentFolder.isSelected === true) {
            return {
              ...currentFolder,
              Folders:
                updatedFolder.Folders.map((subFolder) => {
                  subFolder.isSelected = true;
                  return subFolder;
                }) || [],
              Files:
                updatedFolder.Files.map((subFile) => {
                  subFile.isSelected = true;
                  return subFile;
                }) || [],
            };
          } else if (
            currentFolder.isSelected == undefined ||
            currentFolder.isSelected == false
          ) {
            return {
              ...currentFolder,
              Folders: updatedFolder.Folders || [],
              Files: updatedFolder.Files || [],
            };
          }
        }

        if (currentFolder.Folders && currentFolder.Folders.length > 0) {
          return {
            ...currentFolder,
            Folders: currentFolder.Folders.map((subFolder) =>
              updateFolderInTree(subFolder),
            ),
          };
        }

        return currentFolder;
      };

      if (folder.value) {
        folder.value = updateFolderInTree(folder.value);
      }
    };

    const selectFolder = async (dir: FolderOut, value: boolean) => {
      const hasPartialAccess = value && hasInaccessibleElements(dir);

      const updateTree = (currentFolder: FolderOut): FolderOut => {
        if (currentFolder.Id === dir.Id) {
          return hasPartialAccess
            ? selectAccessibleBranch(currentFolder, true)
            : setBranchSelection(currentFolder, value);
        }

        return {
          ...currentFolder,
          Folders: (currentFolder.Folders ?? []).map((subFolder) =>
            updateTree(subFolder),
          ),
        };
      };

      if (folder.value) {
        folder.value = normalizeSelectionUp(updateTree(folder.value));
      }

      Object.assign(dragGeneralState, selectCountGeneralState());

      if (hasPartialAccess) {
        resetModalPos();
        typeCard.value = "error";
        errorType.value = "chooseAccessDenied";
        await nextTick();
        $fileMoveModal.value?.onOpen();
      }
    };

    const selectFile = async (dirId: number, file: FileOut, value: boolean) => {
      const updateTree = (currentFolder: FolderOut): FolderOut => {
        if (currentFolder.Id === dirId) {
          return {
            ...currentFolder,
            Files: (currentFolder.Files ?? []).map((subFile) =>
              subFile.Id === file.Id
                ? { ...subFile, isSelected: value }
                : subFile,
            ),
          };
        }

        return {
          ...currentFolder,
          Folders: (currentFolder.Folders ?? []).map((subFolder) =>
            updateTree(subFolder),
          ),
        };
      };

      if (folder.value) {
        folder.value = normalizeSelectionUp(updateTree(folder.value));
      }

      Object.assign(dragGeneralState, selectCountGeneralState());
    };

    const selectAll = async () => {
      const selectFolderInTree = (currentFolder: FolderOut): FolderOut => {
        const selectFileInTree = (currentFile: FileOut): FileOut => {
          currentFile.isSelected = true;

          return {
            ...currentFile,
          };
        };

        if (currentFolder.Id !== 0) {
          currentFolder.isSelected = true;
        }
        currentFolder.Files?.map((subFile) => selectFileInTree(subFile));

        if (currentFolder.Folders && currentFolder.Folders.length > 0) {
          return {
            ...currentFolder,
            Folders: currentFolder.Folders.map((subFolder) =>
              selectFolderInTree(subFolder),
            ),
          };
        }

        return currentFolder;
      };

      if (folder.value) {
        folder.value = selectFolderInTree(folder.value);
      }
    };

    const renameFolder = async (dir: number, value: string) => {
      const findFolderAndParent = (
        currentFolder: FolderOut,
        parent: FolderOut | null = null,
      ): { folder: FolderOut | null; parent: FolderOut | null } => {
        if (currentFolder.Id === dir) {
          return { folder: currentFolder, parent };
        }

        if (currentFolder.Folders?.length) {
          for (const subFolder of currentFolder.Folders) {
            const result = findFolderAndParent(subFolder, currentFolder);
            if (result.folder) return result;
          }
        }

        return { folder: null, parent: null };
      };

      if (!folder.value) return;

      const { folder: targetFolder, parent } = findFolderAndParent(
        folder.value,
      );

      if (!targetFolder) return;

      if (parent) {
        const exists = parent.Folders?.some(
          (f) => f.Name.toLowerCase() === value.toLowerCase() && f.Id !== dir,
        );

        if (exists) {
          typeCard.value = "error";
          errorType.value = "folderNameMatch";
          dirFocusId.value = dir;
          pendingRenameFocus.value = "folder";

          nextTick(() => {
            $fileMoveModal.value?.onOpen();
          });

          return;
        }
      }

      const renameInTree = (currentFolder: FolderOut): FolderOut => {
        if (currentFolder.Id === dir) {
          FileApi.RenameDir(value, currentFolder.Id);

          return {
            ...currentFolder,
            Name: value,
          };
        }

        return {
          ...currentFolder,
          Folders: currentFolder.Folders?.map(renameInTree) || [],
        };
      };

      folder.value = renameInTree(folder.value);
    };

    const renameFile = async (dir: number, file: number, value: string) => {
      const updateFolderTree = (currentFolder: FolderOut): FolderOut => {
        if (currentFolder.Id === dir) {
          const exists = currentFolder.Files?.some(
            (f) =>
              f.Name.toLowerCase() === value.toLowerCase() && f.Id !== file,
          );

          if (exists) {
            typeCard.value = "error";
            errorType.value = "fileNameMatch";
            dirFocusId.value = file;
            pendingRenameFocus.value = "file";

            nextTick(() => {
              $fileMoveModal.value?.onOpen();
            });

            return currentFolder;
          }

          return {
            ...currentFolder,
            Files: currentFolder.Files?.map((subFile) => {
              if (subFile.Id === file) {
                FileApi.RenameFile(value, subFile.Id);

                return {
                  ...subFile,
                  Name: value,
                };
              }

              return subFile;
            }),
          };
        }

        if (currentFolder.Folders?.length) {
          return {
            ...currentFolder,
            Folders: currentFolder.Folders.map(updateFolderTree),
          };
        }

        return currentFolder;
      };

      if (folder.value) {
        folder.value = updateFolderTree(folder.value);
      }
    };

    const createFolder = async (dir: FolderOut, value: string) => {
      const selectFolderInTree = async (
        currentFolder: FolderOut,
      ): Promise<FolderOut> => {
        if (currentFolder.Id === dir.Id) {
          let newDir = await FileApi.CreateNewDirectory(
            currentFolder.Id,
            value,
          );

          if (newDir == null) {
            typeCard.value = "error";
            errorType.value = "folderNameMatch";
            pendingRenameFocus.value = "new-folder";

            nextTick(() => {
              $fileMoveModal.value?.onOpen();
            });

            return {
              ...currentFolder,
            };
          }
          currentFolder.Folders.push(newDir);
          if (currentFolder.isSelected == true) {
            newDir.isSelected = true;
          }
          return {
            ...currentFolder,
          };
        }

        if (currentFolder.Folders && currentFolder.Folders.length > 0) {
          const updatedFolders = await Promise.all(
            currentFolder.Folders.map((subFolder) =>
              selectFolderInTree(subFolder),
            ),
          );
          return {
            ...currentFolder,
            Folders: updatedFolders,
          };
        }

        return currentFolder;
      };

      if (folder.value) {
        folder.value = await selectFolderInTree(folder.value);
      }
    };

    const uploadFile = async (
      dir: number,
      value: string,
      formData: FormData,
    ): Promise<boolean> => {
      let isReplace = false;

      const selectFolderInTree = (currentFolder: FolderOut): FolderOut => {
        const selectFileInTree = (currentFile: FileOut): FileOut => {
          if (currentFile.Name.toLowerCase() === value.toLowerCase()) {
            isReplace = true;
          }

          return currentFile;
        };

        if (currentFolder.Id == dir) {
          return {
            ...currentFolder,
            Files: currentFolder?.Files?.map((subFile) =>
              selectFileInTree(subFile),
            ),
          };
        }

        if (currentFolder.Folders && currentFolder.Folders.length > 0) {
          return {
            ...currentFolder,
            Folders: currentFolder.Folders.map((subFolder) =>
              selectFolderInTree(subFolder),
            ),
          };
        }

        return currentFolder;
      };

      if (!folder.value) return false;

      formdataTemp = formData;
      folder.value = selectFolderInTree(folder.value);

      if (isReplace) {
        typeCard.value = "replaceUpload";
        $fileMoveModal.value?.onOpen();

        const replaceChoice = await waitReplaceUploadChoice();

        if (replaceChoice === null) {
          return false;
        }

        if (replaceChoice === true) {
          // Заменить файл
          formdataTemp.append("Type", "1");
        } else {
          // Оставить обе версии
          formdataTemp.append("Type", "0");
        }
      } else {
        formdataTemp.append("Type", "0");
      }

      try {
        const newFile = await FileApi.FileUpload(formdataTemp, (value) => {
          percentUploading.value = value;
        });

        if (!newFile) {
          percentUploading.value = 0;
          return false;
        }

        if (!isReplace || formdataTemp.get("Type") === "0") {
          addFileInFolder(Number(formdataTemp.get("FolderId")), newFile);
        }

        percentUploading.value = 100;
        $fileMoveModal.value?.onClose();
        return true;
      } catch (error) {
        percentUploading.value = 0;
        return false;
      }
    };

    const changeFolderTags = async (
      dirId: number,
      nextTags: FolderOut["Tags"],
      addedTags: TagWithFrequency[],
      removedTags: FolderOut["Tags"],
    ) => {
      try {
        for (const tag of addedTags) {
          await TagsApi.addTag({
            EditingTagId: 0,
            Name: tag.Name,
            EntityType: TagEntityType.Folder,
            EntityId: dirId,
          });
        }

        for (const tag of removedTags) {
          await TagsApi.deleteTag({
            TagId: tag.Id,
            EntityType: TagEntityType.Folder,
            EntityId: dirId,
          });
        }

        const updateFolderTagsInTree = (
          currentFolder: FolderOut,
        ): FolderOut => {
          if (currentFolder.Id === dirId) {
            return {
              ...currentFolder,
              Tags: nextTags,
            };
          }

          return {
            ...currentFolder,
            Folders: (currentFolder.Folders ?? []).map(updateFolderTagsInTree),
          };
        };

        if (folder.value) {
          folder.value = updateFolderTagsInTree(folder.value);
        }
      } catch (error) {
        console.error("Failed to update folder tags", error);
        return false;
      }

      return true;
    };

    const changeFileTags = async (
      fileId: number,
      nextTags: FileOut["Tags"],
      addedTags: TagWithFrequency[],
      removedTags: FileOut["Tags"],
    ) => {
      try {
        for (const tag of addedTags) {
          await TagsApi.AddTag({
            EditingTagId: 0,
            Name: tag.Name,
            EntityType: TagEntityType.File,
            EntityId: fileId,
          });
        }

        for (const tag of removedTags) {
          await TagsApi.deleteTag({
            TagId: tag.Id,
            EntityType: TagEntityType.File,
            EntityId: fileId,
          });
        }

        const updateFileTagsInTree = (currentFolder: FolderOut): FolderOut => {
          return {
            ...currentFolder,
            Files: (currentFolder.Files ?? []).map((currentFile) =>
              currentFile.Id === fileId
                ? {
                    ...currentFile,
                    Tags: nextTags,
                  }
                : currentFile,
            ),
            Folders: (currentFolder.Folders ?? []).map(updateFileTagsInTree),
          };
        };

        if (folder.value) {
          folder.value = updateFileTagsInTree(folder.value);
        }
      } catch (error) {
        console.error("Failed to update file tags", error);
        return false;
      }

      return true;
    };

    const setFileTags = (fileId: number, tags: FileOut["Tags"]) => {
      const updateFileTagsInTree = (currentFolder: FolderOut): FolderOut => {
        return {
          ...currentFolder,
          Files: (currentFolder.Files ?? []).map((currentFile) =>
            currentFile.Id === fileId
              ? {
                  ...currentFile,
                  Tags: tags,
                }
              : currentFile,
          ),
          Folders: (currentFolder.Folders ?? []).map(updateFileTagsInTree),
        };
      };

      if (folder.value) {
        folder.value = updateFileTagsInTree(folder.value);
      }
    };

    const setFolderTags = (dirId: number, tags: FolderOut["Tags"]) => {
      const updateFolderTagsInTree = (currentFolder: FolderOut): FolderOut => {
        if (currentFolder.Id === dirId) {
          return {
            ...currentFolder,
            Tags: tags,
          };
        }

        return {
          ...currentFolder,
          Folders: (currentFolder.Folders ?? []).map(updateFolderTagsInTree),
        };
      };

      if (folder.value) {
        folder.value = updateFolderTagsInTree(folder.value);
      }
    };

    switch (eventData.type) {
      case "select":
        await selectFolder(eventData.data.dir, eventData.data.value);
        syncSelectionState();
        break;

      case "selectFile":
        selectFile(
          eventData.data.dir.Id,
          eventData.data.file,
          eventData.data.value,
        );
        syncSelectionState();
        break;

      case "selectAll":
        selectAll();
        syncSelectionState();
        break;

      case "deselect":
        deselectFolders();
        syncSelectionState();
        break;

      case "open":
        await openFolder(eventData.data.dir);
        syncSelectionState();
        break;

      case "openProject":
        await openProjectFolder(eventData.data.dir);
        syncSelectionState();
        break;

      case "rename":
        renameFolder(
          eventData.data.info == true
            ? eventData.data.dir
            : eventData.data.dir.Id,
          eventData.data.value,
        );
        break;

      case "renameFile":
        renameFile(
          eventData.data.info == true
            ? eventData.data.dir
            : eventData.data.dir.Id,
          eventData.data.info == true
            ? eventData.data.file
            : eventData.data.file.Id,
          eventData.data.value,
        );
        break;

      case "create":
        await createFolder(eventData.data.dir, eventData.data.value);
        syncSelectionState();
        break;

      case "remove":
        typeCard.value = "removeFolder";
        $fileMoveModal.value?.onOpen(eventData.data.dir, countSelected.value);
        syncSelectionState();
        break;

      case "removeFile":
        typeCard.value = "removeFile";
        $fileMoveModal.value?.onOpen(
          eventData.data.dir,
          countSelected.value,
          eventData.data.file,
        );
        syncSelectionState();
        break;

      case "removeElements":
        resetModalPos();
        typeCard.value = "remove";
        $fileMoveModal.value?.onOpen(undefined, countSelected.value);
        syncSelectionState();
        break;

      case "download":
        FileApi.FolderDownload(eventData.data.dir.Id);
        break;

      case "upload":
        return await uploadFile(
          Number(eventData.data.formdata.get("FolderId")),
          String(eventData.data.formdata.get("FileName")),
          eventData.data.formdata,
        );

      case "abort":
        typeCard.value = "abortFile";
        $fileMoveModal.value?.onOpen(
          undefined,
          countSelected.value,
          eventData.data.file,
        );
        break;

      case "replace":
        typeCard.value = "replace";
        formdataTemp = eventData.data.formdata;
        $fileMoveModal.value?.onOpen(
          eventData.data.targetDir,
          countSelected.value,
        );
        syncSelectionState();
        break;

      case "downloadFile":
        await downloadFile(eventData.data.file.Id);
        break;

      case "move":
        resetModalPos();
        typeCard.value = "move";
        pendingMoveOpenFolderId.value = eventData.data.openAfterMove
          ? eventData.data.targetDir.Id
          : null;

        $fileMoveModal.value?.onOpen(
          eventData.data.targetDir,
          countSelected.value,
        );
        syncSelectionState();
        break;

      case "info":
        titleModalInfo.value = String(i18n.global.t("file_folder_information_and_access"));
        container = await FileApi.GetFolderInfo(eventData.data.dir.Id);
        if (container) {
          $fileInfoModal.value?.onOpen(
            container,
            "folder",
            null,
            eventData.data.dir.Tags,
            eventData.data.dir.Editable,
          );
        } else {
          typeCard.value = "error";
          errorType.value = "notFound";
          nextTick(() => {
            $fileMoveModal.value?.onOpen();
          });
        }
        break;

      case "infoParent":
        titleModalInfo.value = String(i18n.global.t("file_folder_information_and_access"));
        container = await FileApi.GetFolderInfo(eventData.data.dir.Id);
        container.Name = containerProject.value?.Name;
        if (container) {
          $fileInfoModal.value?.onOpen(
            container,
            "parentFolder",
            null,
            eventData.data.dir.Tags,
            eventData.data.dir.Editable,
          );
        } else {
          typeCard.value = "error";
          errorType.value = "notFound";
          nextTick(() => {
            $fileMoveModal.value?.onOpen();
          });
        }
        break;

      case "infoFile":
        titleModalInfo.value = String(i18n.global.t("file_information_and_access"));
        containerFile = await FileApi.GetFileInfo(eventData.data.file.Id);
        if (containerFile) {
          isModalOpened.value = true;
          $fileInfoModal.value?.onOpen(
            containerFile,
            "file",
            eventData.data.dir.Id,
            eventData.data.file.Tags,
            eventData.data.file.Editable,
          );
        } else {
          typeCard.value = "error";
          errorType.value = "notFound";
          nextTick(() => {
            $fileMoveModal.value?.onOpen();
          });
        }
        break;

      case "toggleFolder": {
        const { folderId, isOpen, folder, mode } = eventData.data;

        if (mode === "search") {
          if (isOpen) {
            if (!searchOpenedFolderIds.value.includes(folderId)) {
              searchOpenedFolderIds.value.push(folderId);
            }
          } else {
            searchOpenedFolderIds.value = removeBranchFromOpened(
              searchOpenedFolderIds.value,
              folder,
            );
          }
          break;
        }

        if (isOpen) {
          if (!restoreOpenedFolderIds.value.includes(folderId)) {
            restoreOpenedFolderIds.value.push(folderId);
          }
        } else {
          const index = restoreOpenedFolderIds.value.indexOf(folderId);
          if (index !== -1) restoreOpenedFolderIds.value.splice(index, 1);
        }
        break;
      }

      case "error":
        resetModalPos();
        typeCard.value = "error";
        errorType.value = eventData.data.errorType;

        if (eventData.data.focusTarget === "new-folder") {
          pendingRenameFocus.value = "new-folder";
        }
        nextTick(() => {
          $fileMoveModal.value?.onOpen();
        });
        break;

      case "changeFolderTags":
        await changeFolderTags(
          eventData.data.dir.Id,
          eventData.data.tags,
          eventData.data.addedTags,
          eventData.data.removedTags,
        );
        break;

      case "changeFileTags":
        await changeFileTags(
          eventData.data.file.Id,
          eventData.data.tags,
          eventData.data.addedTags,
          eventData.data.removedTags,
        );
        break;

      case "setFolderTags":
        setFolderTags(eventData.data.dir.Id, eventData.data.tags);
        break;

      case "setFileTags":
        setFileTags(eventData.data.file.Id, eventData.data.tags);
        break;
    }
  } catch (error) {
    console.log(error);
    return false;
  }

  return true;
};

provide("childEventEmitter", handleChildEvent);

const onCloseError = () => {
  nextTick(() => {
    if (pendingRenameFocus.value === "folder") {
      renameFolderFocus.value = true;
    } else if (pendingRenameFocus.value === "file") {
      renameFileFocus.value = true;
    } else if (pendingRenameFocus.value === "new-folder") {
      newDirFocus.value = true;
    }

    pendingRenameFocus.value = null;
  });
};

const onSuccessMove = async (targetDir: FolderOut) => {
  await moveSelectedFoldersAndFiles(targetDir);

  if (pendingMoveOpenFolderId.value === targetDir.Id) {
    openAfterMoveFolderId.value = targetDir.Id;

    await nextTick();
    openAfterMoveFolderId.value = null;
    pendingMoveOpenFolderId.value = null;
  }
};

const onSuccessReplace = (value: boolean) => {
  if (value == true) {
    formdataTemp.append("Type", "0");
  } else {
    formdataTemp.append("Type", "1");
  }
  FileApi.replaceFile(formdataTemp);

  if (value == false) {
    const folderId = formdataTemp.get("FolderId");
    const fileId = formdataTemp.get("FileId");
    const filename = formdataTemp.get("Filename");

    renameFileLocal(Number(folderId), Number(fileId), filename);
  }
};

const onSuccessReplaceUpload = (value: boolean) => {
  resolveReplaceUploadChoice?.(value);
  resolveReplaceUploadChoice = null;
};

const onSuccessAbortFile = () => {
  FileApi.AbortUpload();
  percentUploading.value = 0;
};

const renameFileLocal = async (dir: number, file: number, value: string) => {
  const selectFolderInTree = (currentFolder: FolderOut): FolderOut => {
    const selectFileInTree = (currentFile: FileOut): FileOut => {
      if (currentFile.Id === file) {
        return {
          ...currentFile,
          Name: value,
        };
      }

      return currentFile;
    };

    if (currentFolder.Id === dir) {
      return {
        ...currentFolder,
        Files: currentFolder.Files.map((subFile) => selectFileInTree(subFile)),
      };
    }

    if (currentFolder.Folders && currentFolder.Folders.length > 0) {
      return {
        ...currentFolder,
        Folders: currentFolder.Folders.map((subFolder) =>
          selectFolderInTree(subFolder),
        ),
      };
    }

    return currentFolder;
  };

  if (folder.value) {
    folder.value = selectFolderInTree(folder.value);
  }
};

const getSelectedDragEntity = (): DragEntity => {
  if (!folder.value) {
    return {
      type: "selection",
      folders: [],
      files: [],
    };
  }

  const selectedFolders: FolderOut[] = [];
  const selectedFiles: { file: FileOut; parentFolder: FolderOut }[] = [];

  const walk = (currentFolder: FolderOut, parentSelected = false) => {
    const currentSelected = currentFolder.isSelected === true;

    if (currentSelected && !parentSelected && currentFolder.Id !== 0) {
      selectedFolders.push(currentFolder);
      return;
    }

    for (const file of currentFolder.Files ?? []) {
      if (file.isSelected === true) {
        selectedFiles.push({
          file,
          parentFolder: currentFolder,
        });
      }
    }

    for (const child of currentFolder.Folders ?? []) {
      walk(child, parentSelected || currentSelected);
    }
  };

  walk(folder.value);

  return {
    type: "selection",
    folders: selectedFolders,
    files: selectedFiles,
  };
};

const dragState = reactive<DragStateEx>({
  draggedEntity: null,
  draggedElement: null,
  dropTarget: null,
  isValidDrop: false,
});

const dragGeneralState = reactive<DragGeneralState>({
  name: "",
  type: "",
  count: 0,
  active: false,
  isValid: true,
  x: 0,
  y: 0,
});

provide("dragGeneralState", dragGeneralState);

const getSelectedTopLevelFolders = (): FolderOut[] => {
  if (!folder.value) return [];

  const result: FolderOut[] = [];

  const walk = (currentFolder: FolderOut, parentSelected = false) => {
    const currentSelected = currentFolder.isSelected === true;

    if (currentSelected && !parentSelected && currentFolder.Id !== 0) {
      result.push(currentFolder);
    }

    for (const child of currentFolder.Folders ?? []) {
      walk(child, parentSelected || currentSelected);
    }
  };

  walk(folder.value);

  return result;
};

provide("getSelectedTopLevelFolders", getSelectedTopLevelFolders);

const dragTooltip = reactive({
  show: false,
  message: "",
  style: { left: "0px", top: "0px" },
});
const setDragState = (value: Partial<DragStateEx>) => {
  Object.assign(dragState, value);
};

provide("dragState", dragState);
provide("setDragState", setDragState);
provide("getSelectedDragEntity", getSelectedDragEntity);

let touchDrag: {
  identifier: number;
  startX: number;
  startY: number;
  sourceType: "file" | "folder";
  sourceId: number;
  files: { file: FileOut; parent: FolderOut }[];
  folders: FolderOut[];
  active: boolean;
  timer: ReturnType<typeof setTimeout> | null;
  target: FolderOut | null;
  targetElement: HTMLElement | null;
} | null = null;

provide("isFileTouchDragPending", () => touchDrag !== null);

const findTouchFile = (current: FolderOut, id: number): { file: FileOut; parent: FolderOut } | null => {
  const file = current.Files?.find((item) => item.Id === id);
  if (file) return { file, parent: current };
  for (const child of current.Folders ?? []) {
    const found = findTouchFile(child, id);
    if (found) return found;
  }
  return null;
};

const findTouchFolder = (current: FolderOut, id: number): FolderOut | null => {
  if (current.Id === id) return current;
  for (const child of current.Folders ?? []) {
    const found = findTouchFolder(child, id);
    if (found) return found;
  }
  return null;
};

const isTouchFolderDescendant = (
  target: FolderOut,
  source: FolderOut,
): boolean => {
  return (source.Folders ?? []).some(
    (child) =>
      child.Id === target.Id || isTouchFolderDescendant(target, child),
  );
};

const isValidTouchTarget = (
  state: NonNullable<typeof touchDrag>,
  target: FolderOut,
): boolean => {
  if (target.Id === 0 || !target.Editable || target.isSelected) return false;

  const hasInvalidFile = state.files.some(
    ({ file, parent }) =>
      parent.Id === target.Id ||
      target.Files?.some(
        (item) => item.Name.toLowerCase() === file.Name.toLowerCase(),
      ),
  );
  if (hasInvalidFile) return false;

  return !state.folders.some(
    (source) =>
      source.Id === target.Id ||
      isTouchFolderDescendant(target, source) ||
      target.Folders?.some(
        (item) => item.Name.toLowerCase() === source.Name.toLowerCase(),
      ),
  );
};

const clearTouchTarget = () => {
  touchDrag?.targetElement?.classList.remove("folder-dragging-valid");
  if (touchDrag) {
    touchDrag.target = null;
    touchDrag.targetElement = null;
  }
};

const removeFileTouchListeners = () => {
  window.removeEventListener("touchmove", onFileTouchMove, true);
  window.removeEventListener("touchend", onFileTouchEnd, true);
  window.removeEventListener("touchcancel", onFileTouchCancel, true);
  window.removeEventListener("blur", stopFileTouchDrag);
  document.removeEventListener("click", cancelStaleFileTouchDrag, true);
  document.removeEventListener("contextmenu", preventTouchContextMenu);
  document.documentElement.classList.remove("file-touch-drag-active");
};

const stopFileTouchDrag = () => {
  if (touchDrag?.timer) clearTimeout(touchDrag.timer);
  clearTouchTarget();
  touchDrag = null;
  dragGeneralState.active = false;
  removeFileTouchListeners();
};

const preventTouchContextMenu = (event: Event) => {
  if (touchDrag) event.preventDefault();
};

const onFileTouchCancel = () => stopFileTouchDrag();

const cancelStaleFileTouchDrag = () => {
  if (touchDrag?.active) stopFileTouchDrag();
};

const onFileTouchStart = (event: TouchEvent) => {
  if (!advancedMode.value || (props.ruleAccess !== 2 && !isAdmin) || event.touches.length !== 1) return;
  const target = event.target as HTMLElement;
  if (!folder.value) return;

  const fileRow = target
    .closest(".file-item__name, .file-item__icon")
    ?.closest<HTMLElement>(".file-item[data-file-id]");
  const folderRow = target
    .closest(".folder__name, .folder__icon-slot")
    ?.closest<HTMLElement>(".folder[data-folder-id]");

  const fileId = Number(fileRow?.dataset.fileId);
  const folderId = Number(folderRow?.dataset.folderId);
  const fileSource = fileId ? findTouchFile(folder.value, fileId) : null;
  const folderSource = folderId ? findTouchFolder(folder.value, folderId) : null;

  if (fileSource && !fileSource.file.Editable) return;
  if (
    folderSource &&
    (!folderSource.Editable || folderRow?.dataset.folderType !== "default")
  ) return;
  if (!fileSource && !folderSource) return;

  stopFileTouchDrag();
  const touch = event.touches[0];
  touchDrag = {
    identifier: touch.identifier,
    startX: touch.clientX,
    startY: touch.clientY,
    sourceType: fileSource ? "file" : "folder",
    sourceId: fileSource?.file.Id ?? folderSource!.Id,
    files: fileSource ? [fileSource] : [],
    folders: folderSource ? [folderSource] : [],
    active: false,
    timer: null,
    target: null,
    targetElement: null,
  };
  touchDrag.timer = setTimeout(() => {
    if (!touchDrag) return;
    touchDrag.active = true;
    const selection = getSelectedDragEntity();
    const selectedFiles = selection.type === "selection"
      ? selection.files.map(({ file, parentFolder }) => ({
          file,
          parent: parentFolder,
        }))
      : [];
    const selectedFolders = selection.type === "selection"
      ? selection.folders
      : [];
    const sourceIsSelected = touchDrag.sourceType === "file"
      ? selectedFiles.some(({ file }) => file.Id === touchDrag?.sourceId)
      : selectedFolders.some((item) => item.Id === touchDrag?.sourceId);

    if (sourceIsSelected) {
      touchDrag.files = selectedFiles;
      touchDrag.folders = selectedFolders;
    } else {
      void deselectFolders();
      if (touchDrag.sourceType === "file") {
        const source = findTouchFile(folder.value!, touchDrag.sourceId);
        if (!source) return stopFileTouchDrag();
        void handleChildEvent({
          type: "selectFile",
          data: { dir: source.parent, file: source.file, value: true },
        });
      } else {
        const source = findTouchFolder(folder.value!, touchDrag.sourceId);
        if (!source) return stopFileTouchDrag();
        void handleChildEvent({
          type: "select",
          data: { dir: source, value: true },
        });
      }
    }
    dragGeneralState.active = true;
    dragGeneralState.x = touchDrag.startX;
    dragGeneralState.y = touchDrag.startY;
    document.documentElement.classList.add("file-touch-drag-active");
    document.addEventListener("click", cancelStaleFileTouchDrag, true);
  }, 350);
  window.addEventListener("touchmove", onFileTouchMove, { capture: true, passive: false });
  window.addEventListener("touchend", onFileTouchEnd, { capture: true, passive: false });
  window.addEventListener("touchcancel", onFileTouchCancel, { capture: true, passive: false });
  window.addEventListener("blur", stopFileTouchDrag);
  document.addEventListener("contextmenu", preventTouchContextMenu);
};

const onFileTouchMove = (event: TouchEvent) => {
  const state = touchDrag;
  const touch = Array.from(event.touches).find((item) => item.identifier === state?.identifier);
  if (!state || !touch) return;
  if (!state.active) {
    if (Math.hypot(touch.clientX - state.startX, touch.clientY - state.startY) > 10) {
      stopFileTouchDrag();
    }
    return;
  }

  event.preventDefault();
  event.stopPropagation();
  dragGeneralState.x = touch.clientX;
  dragGeneralState.y = touch.clientY;
  if ($folderTreeElement.value) {
    const scrollParent = getScrollParent($folderTreeElement.value);
    const bounds = scrollParent === window
      ? { top: 0, bottom: window.innerHeight }
      : (scrollParent as Element).getBoundingClientRect();
    const scrollBy = touch.clientY < bounds.top + 48 ? -16
      : touch.clientY > bounds.bottom - 48 ? 16 : 0;
    if (scrollBy) {
      if (scrollParent === window) window.scrollBy(0, scrollBy);
      else (scrollParent as Element).scrollBy(0, scrollBy);
    }
  }
  clearTouchTarget();
  const row = document.elementFromPoint(touch.clientX, touch.clientY)?.closest<HTMLElement>(".folder[data-folder-id]");
  if (!row || !$folderTreeElement.value?.contains(row) || row.dataset.folderType === "systemProjectList") return;
  const targetId = Number(row.dataset.folderId);
  const target = folder.value && findTouchFolder(folder.value, targetId);
  if (!target || !isValidTouchTarget(state, target)) return;
  state.target = target;
  state.targetElement = row;
  row.classList.add("folder-dragging-valid");
};

const onFileTouchEnd = async (event: TouchEvent) => {
  const state = touchDrag;
  if (!state || !Array.from(event.changedTouches).some((item) => item.identifier === state.identifier)) return;
  if (state.active) {
    event.preventDefault();
    event.stopPropagation();
  }
  const target = state.active ? state.target : null;
  stopFileTouchDrag();
  if (!target) return;
  try {
    const latest = await FileApi.getChildFolders(target.Id);
    if (!advancedMode.value || !folder.value) return;
    const sourceStillExists = state.sourceType === "file"
      ? findTouchFile(folder.value, state.sourceId)
      : findTouchFolder(folder.value, state.sourceId);
    if (!sourceStillExists) return;
    const hydratedTarget = {
      ...target,
      Folders: latest.Folders ?? [],
      Files: latest.Files ?? [],
    };
    if (!isValidTouchTarget(state, hydratedTarget)) return;
    await handleChildEvent({ type: "move", data: { targetDir: target, openAfterMove: true } });
  } catch (error) {
    console.error(error);
  }
};

onBeforeUnmount(stopFileTouchDrag);

watch(
  () => props.rootName,
  (rootName) => {
    if (!rootName || searchMode.value) return;

    if (folder.value) {
      folder.value = { ...folder.value, Name: rootName };
    }
    if (containerProject.value) {
      containerProject.value = {
        ...containerProject.value,
        Name: rootName,
      };
    }
  },
);

watch(
  () => props.id,
  () => {
    loadFolders();
    searchMode.value = false;
    searchText.value = "";
  },
  { immediate: true },
);

watch(
  () => [props.id, props.type, searchStoreInstance.pendingFileSearch] as const,
  () => consumeFileSearchRequest(),
);

onMounted(() => {
  window.addEventListener(
    FILE_JOB_BINDING_ADDED_EVENT,
    handleFileJobBindingAdded,
  );
  deselectFolders();
  consumeFileSearchRequest();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(FileInfoModal, {
      ref_key: "$fileInfoModal",
      ref: $fileInfoModal,
      title: titleModalInfo.value,
      type: typeInfoModal.value,
      "rule-access": _ctx.ruleAccess,
      "client-id": _ctx.type == 'client' ? _ctx.id : 0,
      "project-id": _ctx.type == 'project' ? _ctx.id : 0
    }, null, 8, ["title", "type", "rule-access", "client-id", "project-id"]),
    _createVNode(FileMoveModal, {
      ref_key: "$fileMoveModal",
      ref: $fileMoveModal,
      onSuccessMove: onSuccessMove,
      onSuccessRemove: removeSelectedFoldersAndFiles,
      onSuccessRemoveFile: removeFile,
      onSuccessRemoveFolder: removeFolder,
      onSuccessReplace: onSuccessReplace,
      onSuccessReplaceUpload: onSuccessReplaceUpload,
      onSuccessAbortFile: onSuccessAbortFile,
      onCloseError: onCloseError,
      position: modalPos.value,
      type: typeCard.value,
      "error-type": errorType.value
    }, null, 8, ["position", "type", "error-type"]),
    _createElementVNode("div", {
      ref_key: "$fileBlock",
      ref: $fileBlock,
      class: "file-block"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("files")), 1),
        _createElementVNode("div", {
          class: "file-block__header-mode",
          onClick: changeMode
        }, _toDisplayString(_ctx.$t(advancedMode.value ? "file_standard_mode" : "file_advanced_mode")), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(AppInput, {
            modelValue: searchText.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchText).value = $event)),
            "show-search-button": true,
            onSearch: searchFolders,
            onPressEnter: searchFolders,
            onPressEsc: onPressEsc
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(AppHashtag, {
            ref: "hashtagRef",
            class: "file-item__string-hashtag",
            items: searchTags.value,
            "selector-enabled": true,
            "tooltip-text": _ctx.$t('ui_tag_filter'),
            "selector-value": selectedTags.value,
            "entity-type": _unref(TagEntityType).Folder,
            "onUpdate:selectorValue": changeTags,
            onRemove: removeTag
          }, null, 8, ["items", "tooltip-text", "selector-value", "entity-type"])
        ])
      ], 512),
      (advancedMode.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(AppButton, {
              label: _ctx.$t('file_select_all'),
              type: "link",
              class: "file-block__advanced-mode-button",
              onClick: selectAll
            }, null, 8, ["label"]),
            (countSelected.value !== 0)
              ? (_openBlock(), _createBlock(AppButton, {
                  key: 0,
                  label: _ctx.$t('file_clear_selection'),
                  type: "link",
                  class: "file-block__advanced-mode-button",
                  onClick: deselectAll
                }, null, 8, ["label"]))
              : _createCommentVNode("", true),
            (countSelected.value !== 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(AppTooltip, {
                    text: _ctx.$t('file_download_selected'),
                    style: {"height":"18px"}
                  }, {
                    activator: _withCtx(() => [
                      _createVNode(AppIcon, {
                        name: "download",
                        width: "18px",
                        color: "#979797",
                        "hover-color": "#499259",
                        cursor: "pointer",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (downloadSelectedFoldersAndFiles($event)))
                      })
                    ]),
                    _: 1
                  }, 8, ["text"]),
                  (dragGeneralState.isValid && (_ctx.ruleAccess === 2 || _unref(isAdmin)))
                    ? (_openBlock(), _createBlock(AppTooltip, {
                        key: 0,
                        text: _ctx.$t('file_delete_selected'),
                        style: {"height":"18px"}
                      }, {
                        activator: _withCtx(() => [
                          _createVNode(AppIcon, {
                            name: "delete-outline",
                            width: "18px",
                            color: "#979797",
                            "hover-color": "#D05A4F",
                            cursor: "pointer",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (handleChildEvent({ type: 'removeElements' })))
                          })
                        ]),
                        _: 1
                      }, 8, ["text"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "file-block__line" }, null, -1)),
      _createElementVNode("div", {
        ref_key: "$folderTreeElement",
        ref: $folderTreeElement,
        onTouchstartCapture: onFileTouchStart
      }, [
        (!isLoading.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_unref(folder) && ((_unref(folder).Folders && _unref(folder).Files) || !searchMode.value))
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    (_unref(folder))
                      ? (_openBlock(), _createBlock(FileFolder, {
                          key: 0,
                          folder: _unref(folder),
                          "folder-type": "systemFolder",
                          "root-folder": true,
                          "rule-access": _ctx.ruleAccess
                        }, null, 8, ["folder", "rule-access"]))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t("file_not_found_plural")), 1))
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(AppLoader, { class: "file-block__loader-icon" })
            ]))
      ], 544)
    ], 512),
    (dragGeneralState.active)
      ? (_openBlock(), _createBlock(FileDragElement, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})